/**
 * Правила вложений — общие с приложением (client-core/tasks/attachments).
 * Здесь — их привязка к «скрепке» и вставке из буфера.
 */

import { ALLOWED_TYPES, attachmentProblem } from "@taskflow/client-core/tasks";

import { type AttachOptions, toast } from "@/shared/ui";

export {
  ALLOWED_TYPES,
  attachmentMime,
  attachmentProblem,
  isPlayableVideo,
  isPreviewableImage,
} from "@taskflow/client-core/tasks";

/** Журнал сетевых запросов записи бага: открывается просмотром в карточке. */
export function isHarLog(file: { mime: string; filename: string }): boolean {
  return file.mime === "application/json" && /\.har$/i.test(file.filename);
}

/** Журнал консоли записи бага (имя задаёт RecordingControl.logFiles). */
export function isConsoleLog(file: { mime: string; filename: string }): boolean {
  return file.mime === "text/plain" && /^Консоль .+\.txt$/i.test(file.filename);
}

/** Одни и те же правила для «скрепки», перетаскивания и вставки из буфера:
 *  разойдись они, Ctrl+V пропускал бы то, что отвергает выбор файла. */
export const ATTACH_OPTIONS: AttachOptions = {
  accept: ALLOWED_TYPES.join(","),
  validate: attachmentProblem,
  onRejected: (file, reason) => toast.warning(reason, file.name),
};
